export const INSTAGRAM_URL = "https://www.instagram.com/vyora.evt?stkn=MXJmYnZybnZnYzNydw%3D%3D&utm_source=qr";
export const TIKTOK_URL = "https://www.tiktok.com/@vyoraevents2026?_r=1&_t=ZG-99YVY4q22pE";
